/** This is example constants. This constants is never used. */

export const GET_TOGGLE_SIDEBAR = 'GET_TOGGLE_SIDEBAR'
export const SET_TOGGLE_SIDEBAR = 'SET_TOGGLE_SIDEBAR'
